import { Component } from '@angular/core';

@Component({
    selector: 'spinner',
    template: require('./../../templates/common/spinner.component.html'),
    styles: [require('./../../styles/common/spinner.component.css')]
})
export class SpinnerComponent {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/components/common/spinner.component.ts